var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{name: 'push_info', params: {pushId: _vm.pushId}}}},[_vm._v("\n  Push "+_vm._s(_vm.pushId)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }